import { history } from "../../src/index";

import * as types from '../constants/customerdetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as customerdetailsApi from '../api/customerdetails';

export function resetCustomer() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_CUSTOMER_RESET });
    }
}

exports.getIsCheckerOrADEnabled = function () {
    // console.log("getIsCheckerOrADEnabled==>");
    return (dispatch, getState) => {
        let _state = getState()
        if (_state && _state.getCustomer && _state.getCustomer.isCheckerEnabled && _state.getCustomer.isADEnabled) {
            // console.log('loadswitchercommittees loaded from CACHE')
        }
        else {
            dispatch({ type: types.FETCH_IS_CHECKER_REQUEST });
            customerdetailsApi.getIsCheckerOrADEnabled()
                .then(function (response) {
                    // console.log("fetchCustomerDetails", response)
                    dispatch({ type: types.FETCH_IS_CHECKER_REQUEST_COMPLETED, data: response.data });
                })
                .catch(function (err) {
                    // console.log("fetchCustomerDetails Error", err)
                    dispatch({ type: types.FETCH_IS_CHECKER_REQUEST_ERROR, error: err });
                });
        }
    }
}


export function fetchCustomerDetails(id) {
    // console.log("fetchCustomerDetails action call", id);
    return dispatch => {
        dispatch({ type: types.FETCH_CUSTOMER_REQUEST });
        customerdetailsApi.getCustomerList(id)
            .then(function (response) {
                // console.log("fetchCustomerDetails", response)
                dispatch({ type: types.FETCH_CUSTOMER_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("fetchCustomerDetails Error", err)
                dispatch({ type: types.FETCH_CUSTOMER_REQUEST_ERROR, error: err });
            });
    }
}

export function fetchCustomerDetailsList() {
    // console.log("fetchCustomerDetailsList action call");
    return (dispatch, getState) => {
        dispatch({ type: types.FETCH_CUSTOMER_LIST_REQUEST });
        customerdetailsApi.getCustomerList()
            .then(function (response) {
                // console.log("fetchCustomerDetailsList", response)
                dispatch({ type: types.FETCH_CUSTOMER_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("fetchCustomerDetailsList Error", err)
                dispatch({ type: types.FETCH_CUSTOMER_LIST_REQUEST_ERROR, error: err });
            });
    }
}

export function addCustomerDetails(objModel) {
    // console.log("addCustomerDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_CUSTOMER_REQUEST });
        customerdetailsApi.addCustomer(objModel)
            .then(function (response) {
                // console.log("addCustomerDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_CUSTOMER_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/customer/customer-list');
                }
            })
            .catch(function (err) {
                // console.log("addCustomerDetails action err", err.response.data.message)
                dispatch({ type: types.ADD_CUSTOMER_REQUEST_ERROR });
            });
    }
}


// WEBPACK FOOTER //
// ./actions/customerdetails.js